import { render, staticRenderFns } from "./FreightTableFormSection.vue?vue&type=template&id=657a215c&scoped=true"
import script from "./FreightTableFormSection.vue?vue&type=script&lang=js"
export * from "./FreightTableFormSection.vue?vue&type=script&lang=js"
import style0 from "./FreightTableFormSection.vue?vue&type=style&index=0&id=657a215c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a215c",
  null
  
)

export default component.exports